/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();

  if (window) {
    window.console.log =
      window.console.warn =
      window.console.info =
        () => {
          // Don't log anything.
        };
  }
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
